import { render } from "./app-form-radio.vue?vue&type=template&id=627da9aa"
import script from "./app-form-radio.vue?vue&type=script&lang=js"
export * from "./app-form-radio.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/components/form/app-form-radio.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "627da9aa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('627da9aa', __exports__)) {
    console.log('reload')
    api.reload('627da9aa', __exports__)
  }
  
  module.hot.accept("./app-form-radio.vue?vue&type=template&id=627da9aa", () => {
    console.log('re-render')
    api.rerender('627da9aa', render)
  })

}


export default __exports__